<template>
  <div class="search-base search-container">
    <search-filter-item
      v-if="layout === 'filter'"
      ref="searchFilterItem"
      :label="label"
      @remove="onClickFilterRemove"
    >
      <div class="flex items-center gap-2">
        <vs-select class="w-full" autocomplete v-model="quarter" @change="change" :disabled="readonly">
          <vs-select-item v-for="(quarter, index) in quarterList" :key="index" :text="quarter.text" :value="quarter.value" />
        </vs-select>
        {{ afterFix }}
      </div>
    </search-filter-item>
    <search-label-body v-else :label="label" :label-hidden="labelHidden" :columns="options['gridTemplateColumns']">
      <div class="flex items-center gap-2">
        <vs-select class="w-full" :class="onlyNum ? 'xl:w-16' : 'xl:w-32'" autocomplete v-model="quarter" @change="change" :disabled="readonly">
          <vs-select-item v-for="(quarter, index) in quarterList" :key="index" :text="quarter.text" :value="quarter.value" />
        </vs-select>
        <span v-if="!isMobile">{{ afterFix }}</span>
      </div>
    </search-label-body>
  </div>
</template>

<script>
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";
import SearchFilterItem from "@/views/list/components/base/SearchFilterItem.vue";

export default {
  name: "SearchYearQuarter",
  components: {
    SearchFilterItem,
    SearchLabelBody,
  },
  props: {
    label: {
      default: "분기",
      type: String,
    },
    value: [String, Number],
    setRef: Function,
    readonly: Boolean,
    query: {
      type: Object,
      default: () => {
        return {
          quarter: "",
        };
      },
    },
    options: Object,
  },
  watch: {
    value(value) {
      this.quarter = value;
    },
  },
  computed: {
    layout() {
      return this.options && this.options.layout ? this.options.layout : 'default';
    },
    isMobile() {
      return !(this.$store.state.verticalNavMenuWidth === "default");
    },
    defaultValue () {
      return this.options && this.options["default"] ? this.options["default"] : "";
    },
    initData() {
      const defaultValue = this.defaultValue;
      const _query_keys = Object.keys(this.query);
      const query = this.$route.query;
      const quarter = query[_query_keys[0]];
      if (quarter) {
        try {
          return {
            quarter: quarter || defaultValue,
          };
        } catch (e) {}
      }
      return {
        quarter: defaultValue,
      };
    },
    quarterList() {
      if (this.onlyNum) {
        return [
          { text: "1", value: 1 },
          { text: "2", value: 2 },
          { text: "3", value: 3 },
          { text: "4", value: 4 },
        ];
      } else {
        return [
          { text: "1분기", value: 1 },
          { text: "2분기", value: 2 },
          { text: "3분기", value: 3 },
          { text: "4분기", value: 4 },
        ];
      }
    },
    afterFix() {
      return this.options && this.options.afterFix || "";
    },
    onlyNum() {
      return this.options && this.options.onlyNum || false;
    },
    labelHiddenResolution () {
      return this.options && this.options.labelHiddenResolution || 'none'
    },
    labelHidden() {
      // labelHiddenResolution 이상의 해상도에서는 label 을 보여주지 않음
      const target = this.labelHiddenResolution;
      const screens = this.$viewport.screens;
      const start = screens.indexOf(target);
      if (start > -1) {
        for (let i = start; i < screens.length; i++) {
          if (this.$viewport.screen === screens[i]) {
            return true;
          }
        }
      }

      if (this.showLabel === 'mobile' && !this.isMobile) {
        return true;
      }

      if (this.isMobile || !this.lastLabel) {
        return false;
      }
      return true;
    },
  },
  data() {
    return {
      quarter: "",
    };
  },
  created() {
    this.quarter = this.initData.quarter;
    this.$emit("input", this.quarter);
  },
  mounted() {
    if (this.setRef) {
      // filter 모드에서 초기화 버튼 클릭시 검색조건을 초기화 하기 위해서 ref 를 연결해주기 위함
      this.setRef('searchFilterItem', this.$refs.searchFilterItem)
    }
  },
  methods: {
    change(data) {
      this.$emit("input", data);
    },
    onClickFilterRemove () {
      this.quarter = this.defaultValue;
      this.$emit("input", this.quarter);
    }
  },
};
</script>
